const { default: axios } = require("axios");

const Notification = function () {

    let notificationChannel = null;
    let notificationChannelName = null;
    let isWSStarted = false;
    let isUnloadBound = false;

    const isUserLoggedIn = () => Number(user_logged_id) > 0;
    const isLoginPage = () => window.location.pathname === "/login";

    const pulseNotificationButton = () => {
        $('.btn-notif').addClass('pulse');
    };

    const playNotificationAudio = () => {
        const audioNotification = document.getElementById('audio-notification');
        if (audioNotification) {
            audioNotification.play().catch(() => { });
        }
    };

    const handleNotificationSuccess = () => {
        pulseNotificationButton();
        playNotificationAudio();
    };

    const createBeamsClient = () => new PusherPushNotifications.Client({
        instanceId: '9f2735cb-c69f-4e02-b83c-820c1f1d0902',
    });

    const cleanupNotificationChannel = () => {
        if (notificationChannel && typeof notificationChannel.stopListening === 'function') {
            notificationChannel.stopListening('SendNotification');
            notificationChannel.stopListening('NotificationEvent');
        }

        if (notificationChannelName && typeof Echo !== 'undefined' && typeof Echo.leave === 'function') {
            Echo.leave(notificationChannelName);
        }

        notificationChannel = null;
        notificationChannelName = null;
        isWSStarted = false;
    };

    const destroy = () => {
        if (typeof window !== 'undefined' && isUnloadBound) {
            window.removeEventListener('beforeunload', destroy);
            window.removeEventListener('pagehide', destroy);
            isUnloadBound = false;
        }

        cleanupNotificationChannel();
    };

    const bindUnloadCleanup = () => {
        if (typeof window === 'undefined' || isUnloadBound) {
            return;
        }

        window.addEventListener('beforeunload', destroy);
        window.addEventListener('pagehide', destroy);
        isUnloadBound = true;
    };

    const startWS = () => {
        if (typeof Echo === 'undefined' || !isUserLoggedIn() || active_notifications == 0 || isWSStarted) {
            return;
        }

        cleanupNotificationChannel();
        bindUnloadCleanup();

        notificationChannelName = 'notification.' + client_name;
        notificationChannel = Echo.private(notificationChannelName)
            .listen('SendNotification', (response) => {
                axios.post(window.location.origin + "/notification/hub", response)
                    .then(() => {
                        handleNotificationSuccess();
                    });
            })
            .listen('NotificationEvent', (response) => {
                if (user_logged_id == response.user_id) {
                    axios.post(window.location.origin + "/notification/recive", response)
                        .then((responseAxios) => {
                            const data = responseAxios.data;
                            if (data.error == false) {
                                handleNotificationSuccess();
                            }
                        });
                }
            });

        isWSStarted = true;
    };

    const beams = () => {
        const beamsClient = createBeamsClient();

        if (isLoginPage()) {
            beamsClient
                .start()
                .then((client) => client.getDeviceId())
                .then((deviceId) => console.log("Successfully registered with Beams. Device ID:", deviceId))
                .then(() => beamsClient.clearAllState())
                .then(() => beamsClient.clearDeviceInterests())
                .catch(console.error);

            return;
        }

        if (!isUserLoggedIn() || active_notifications === 0) {
            return;
        }

        const interest = client_name + '-' + user_logged_id;

        beamsClient
            .start()
            .then((client) => client.getDeviceId())
            .then((deviceId) => console.log("Successfully registered with Beams. Device ID:", deviceId))
            .then(() => beamsClient.addDeviceInterest(interest))
            .then(() => beamsClient.getDeviceInterests())
            .then((interests) => console.log("Current interests:", interests))
            .catch(console.error);
    };

    return {
        init: () => {
            startWS();
            beams();
        },

        destroy: () => {
            destroy();
        }
    };
}();

module.exports = Notification;